class ModalVideo {
  elements;
  modal!: Element;
  constructor() {
    this.elements = document.querySelectorAll('[data-trigger="modal"]');
    if (this.elements.length > 0) {
      this._init();
    }
  }

  _init() {
    this.createModal();
    this.actionOpenModal();
  }

  private createModal():void {
    // modal
    const div = document.createElement('div');
    
    div.id = "modal";

    // close button 
    const close = document.createElement("div");
    close.classList.add('modal-video__close');
    close.setAttribute('data-trigger', 'close-modal');
    close.textContent = "X";

    div.appendChild(close);

    // add modal
    this.modal = div;
    document.body.appendChild(div);  
    // this.openModal();
  }
  
  private openModal(): void{
    document.body.classList.add('modal-video__layout');
    
    document.getElementById('modal')?.classList.add('modal-video__popin');
    // action close modal
    this.actionCloseModal();
  }

  private actionOpenModal():void{
    this.elements.forEach((element: Element) => {
      element.addEventListener('click', (e) => {
        this.openModal();
        const url = element.getAttribute('data-target') ;
        console.log(this.modal);
        this.modal.innerHTML += `<iframe src="https://www.youtube.fr/embed/${url}?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`
        e.stopPropagation()
      });
    });
  }

  private actionCloseModal():void{
    const closeButton = document.querySelector('[data-trigger="close-modal"]');
    console.log(closeButton);
    closeButton?.addEventListener('click', () => {
      // document.getElementById('modal')?.remove();
      this.modal.classList.remove('modal-video__popin');
      this.modal.querySelector('iframe')?.remove();

      document.body.classList.remove("modal-video__layout");
    });
    document.getElementsByClassName('modal-video__layout')[0].addEventListener('click', () => {
      // console.log("test");
      this.modal.classList.remove('modal-video__popin');
      this.modal.querySelector('iframe')?.remove();
      document.body.classList.remove("modal-video__layout");
    });
  }
}

export const modalVideo = new ModalVideo();